export var initImageSizeSetting = function (column) {
    var setting = column.getElement().querySelector('.ac-column-setting--image');
    if (setting) {
        new ImageSizeSetting(column, setting);
    }
};
var ImageSizeSetting = /** @class */ (function () {
    function ImageSizeSetting(column, setting) {
        this.column = column;
        this.setting = setting;
        this.field = this.setting.querySelector('.ac-setting-input select');
        this.initState();
        this.bindEvents();
    }
    ImageSizeSetting.prototype.getValue = function () {
        return this.field.value;
    };
    ImageSizeSetting.prototype.bindEvents = function () {
        var _this = this;
        this.field.addEventListener('change', function () { return _this.initState(); });
    };
    ImageSizeSetting.prototype.initState = function () {
        this.toggleSubSettings('cpac-custom' === this.getValue());
    };
    ImageSizeSetting.prototype.toggleSubSettings = function (show) {
        if (show === void 0) { show = true; }
        this.setting.querySelectorAll('.ac-column-setting').forEach(function (setting) { return setting.style.display = show ? 'table' : 'none'; });
    };
    return ImageSizeSetting;
}());
export { ImageSizeSetting };
